module.exports = __webpack_public_path__ + "img/Icon ionic-ios-arrow-round-forward.c6e8af85.svg";